var Base = require('_js/base'),
  ko = require('knockout');

var model = function(params) {
  this.params = params;
};

function ProfileBureauEmployeeList() {
  this.init();
}

ProfileBureauEmployeeList.prototype = new Base();

ProfileBureauEmployeeList.prototype.init = function() {
  var bureauList = $('[data-bureau-employee-list]');
  if (bureauList.get(0) !== undefined) {
    bureauList.each(function() {
      ko.applyBindings(new model($(this).data('bureau-employee-list')), this);
    });
  }
};

module.exports = ProfileBureauEmployeeList;
